import axios from 'axios'
const state = {
    loading: false,
    brands: [],
    brand: {
        id: null,
        exchange_updatable: 1,
        exchange_records: {  
            tableHeaders: [],
            tableData: [],
            accessTableData: [],
            loading: false,
            tableMeta: {
                total: 10,
                page: 1,
                perpage: 1000,
            },
        },
        information: {
          name: '',
          code: {
            desc: "Code",
            value: "",
          },
          exchange: {
            desc: "Exchange",
            value: null,
          },
        }
    },
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getBrand(state) {
        return state.brand
    },
    getBrands(state) {
        return state.brands
    },
    getTableOptions(state) {
        return state.tableOptions
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setBrand(state, brand) {
        state.brand.id = brand.id;
        state.brand.exchange_updatable = brand.exchange_updatable;
        state.brand.information.name = brand.name;
        state.brand.information.code.value = brand.code;
        state.brand.information.exchange.value = brand.exchange;
        state.brand.exchange_records.tableHeaders = ["date","Exchange","settings",];
        state.brand.exchange_records.tableData = brand.exchange_records;
        state.brand.exchange_records.accessTableData = [["date"],["exchange"],];
        
    },
    setBrands(state, brands) {
        state.brands = brands
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {
    async fetchBrands({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/catalog/brand", {
                params,
            });
            commit('setBrands', response.data.data)
            // commit('setTableData', {
            //     tableHeaders: [
            //         "name",
            //         "Code",
            //         "Exchange",
            //         "settings",
            //     ],
            //     tableData: response.data.data,
            //     accessTableData: [
            //         ["name"],
            //         ["code"],
            //         ["exchange"],
            //     ],
            //     tableMeta: {
            //         total: response.data.meta.total,
            //         page: response.data.meta.current_page,
            //     },
            // })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchBrand({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/accounting/coin/${id}`);
            commit('setBrand', response.data.data);
            state.brand.information.exchange_records.tableMeta = {
                total: response.data.meta.total,
                page: response.data.meta.current_page,
                perpage: response.data.meta.per_page,
            };
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}